// File: IPRegistrationDispute.jsx
import React from "react";

export default function IPRegistrationDispute() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Copyright / Patent / Design Registration / IP Dispute
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks protects intellectual property rights through registrations and dispute resolution.
          </p>
          <p className="text-gray-700">
            Complete IP protection including Copyright Office filing, Patent Office applications, Design Registry submissions, trademark oppositions, and IP litigation support.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: IP protection - patents/designs/legal documents) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="IP registration and protection services"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless IP registrations.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Creative/technical documents (artwork/specifications)</li>
                <li>Identity proof (PAN/Aadhaar)</li>
                <li>Power of attorney/noc</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Strong IP advisory and legal support with proven success in Copyright, Patent, Design, and Trademark registrations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Copyright Registration Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Form XIV filing with Copyright Office, artistic/literary/scientific work protection, 6 months expedited processing, certificate issuance, renewal support, and infringement legal notices.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Patent & Design Registration
                </h3>
                <p className="text-gray-700 text-sm">
                  Patent Form 1/2/3/5 applications, invention specification drafting, Design Form 1 filing, novelty searches, examination report responses, opposition handling, and IP India portal management.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  IP Dispute Resolution
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service IP litigation including cease & desist notices, trademark oppositions, patent infringement suits, design rectification applications, IP court representation, settlement negotiations, and enforcement advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
